interface ProductTypeCardProps {
  title: string
  subTitle: string
  isSelected: boolean
  className?: string
  disabled?: boolean
  onClick: () => void
}

const ProductTypeCard = ({
  title,
  subTitle,
  isSelected,
  className = null,
  disabled = false,
  onClick,
}: ProductTypeCardProps) => {
  return (
    <button
      className={`${className} py-24 flex flex-col items-center justify-center gap-y-4 border rounded-lg ${
        isSelected ? 'bg-purple-50 border-purple-300' : ''
      } ${disabled ? 'cursor-not-allowed bg-black/30' : 'cursor-pointer'}`}
      disabled={disabled}
      onClick={() => onClick()}
    >
      <span className={`Headline2-24Bd ${isSelected ? 'text-purple-500' : 'text-gray-500'}`}>{title}</span>
      <span className={`Body1-16Md ${isSelected ? 'text-purple-500' : 'text-gray-500'}`}>{subTitle}</span>
    </button>
  )
}

export default ProductTypeCard
